export default "__VITE_ASSET__BkWm7XRy__"